<template>
  <div>
    <div>
      <div class="font16 col333 line30 font600">预约看房</div>
      <el-input placeholder="请输入内容" v-model="tel" class="wid300">
        <el-button class="please" slot="append" @click="rulePhone"
          >立即委托</el-button
        >
      </el-input>
      <div v-if="rules" class="font12 colred mart5">
        <i class="el-icon-warning-outline colred"></i>请输入正确的票号格式！
      </div>
    </div>
    <el-dialog
      title="输入验证码"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="30%"
      :before-close="handleClose"
    >
      <el-input placeholder="请输入内容" v-model="vercode" >
        <el-button v-if="!show" type="info" slot="append" 
          >{{count}}'s后可重新发送</el-button
        >
        <el-button v-if="show" type="danger" slot="append" @click="getVer" class="bgred"
          >获取验证码</el-button
        >
      </el-input>
      <div v-if="tip">已发送验证码到{{ geTel(tel) }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="submit" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      rules: false,
      vercode: "",
      tel: "",
      tip: false,
      intervalBtn: null,
      show: true,
      count: '',
      timer: null,
    };
  },
  props: ["paramsid", "type"],
  components: {},
  methods: {
    submit() {
      let dto = {
        code: this.vercode,
        mobile: this.tel,
        params2: this.paramsid, //房源编号
        type: this.type //房源类型 1 房 2 樓盤
      };

      if (this.vercode != "") {
        this.$post(this.$api.Code.saveEntrust, dto).then(res => {
          console.log("rescode", res);
          if (res.code == 0) {
            // this.$set(this.data, "tip", true);
            this.tip = true;
            this.$message({
              showClose: true,
              message: "委托成功！",
              type: "success"
            });
            this.dialogVisible = false;
            // this.tip = true;
          }
        });
      } else {
        this.$message({
          message: "验证码不能为空哦！",
          type: "warning"
        });
      }
    },
    geTel(tel) {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    //   获取验证码
    getVer() {
      var formData = new FormData();
      formData.append("mobile", this.tel);

      let _this = this;
     const TIME_COUNT =30;
     if (!this.timer) {
       this.count = TIME_COUNT;
       this.show = false;
      this.$post(this.$api.Code.sendCode, formData).then(res => {
          if (res.code == 0) {
            this.tip = true;
          }
        });
       this.timer = setInterval(() => {
       if (this.count > 0 && this.count <= TIME_COUNT) {
         this.count--;
        } else {
         this.show = true;
         clearInterval(this.timer);
         this.timer = null;
        }
       }, 1000)
     }
    
    },
    // 检查手机号格式
    rulePhone() {
      if (this.tel != "") {
        if (/^1\d{10}$/.test(this.tel)) {
          this.dialogVisible = true;
          this.rules = false;
        } else {
          this.rules = true;
        }
      } else {
        this.rules = true;
      }
    },
    handleClose(done) {
      done();
    }
  }
};
</script>

<style  lang="scss">
.bgred{
  background: red !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/entrust.vue